// extracted by mini-css-extract-plugin
export default {"sort":"OF-z","sortSelect":"PF-z","disabled":"QF-z"};